/* eslint-disable */
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';

// URL functions
import { fetchKardiaRxIdtfEcg, cctResendEosReport, cctCompletedCheckboxPatientDrawer } from 'legacy/containers/ApiUrls';

// Constants Types
import ROUTE_PATHS from '../../../routes/routePaths';
import {
  CCT_PATIENT_HISTORY_DATA_REQUEST,
  CCT_PATIENT_HISTORY_DATA_SUCCESS,
  CCT_PATIENT_HISTORY_DATA_FAILURE,
  CCT_PATIENT_HISTORY_SELECTED_PATIENT,
  CCT_PATIENT_HISTORY_SELECTED_RECORDING,
  CCT_PATIENT_HISTORY_COMPLETED,
  CCT_RESEND_EOS_REPORT,
} from './types';

import history from '../../../legacy/containers/History';

// ------------------------------------
// Actions
// ------------------------------------
export const kardiRxCctEcgTableDataRequest = () => ({
  type: CCT_PATIENT_HISTORY_DATA_REQUEST,
});
export const kardiRxCctEcgTableDataSuccess = data => ({
  type: CCT_PATIENT_HISTORY_DATA_SUCCESS,
  payload: data,
});
export const kardiRxCctEcgTableDataFailure = () => ({
  type: CCT_PATIENT_HISTORY_DATA_FAILURE,
});

export const updateRxPatient = patient => ({
  type: CCT_PATIENT_HISTORY_SELECTED_PATIENT,
  payload: patient,
});

export const updateRxRecording = rec => ({
  type: CCT_PATIENT_HISTORY_SELECTED_RECORDING,
  payload: rec,
});

export const setInitialKardiaRxCCTEcgTableData = (match, location) => (
  dispatch,
  getState,
) => {
  const {
    participantId,
    connectionTemplateID,
  } = getState().kardiaRx.kardiaRxCCTPatientHistory.selectedPatinet;
  // const { patientId } = match.params;
  // const { search } = location;
  // const templetArr = search.split('templateID=');
  dispatch(
    updateRxPatient({
      participantId,
      connectionTemplateID,
    }),
  );
};

export const getKardiaRxCCTEcgHistory = (params, forceUpdate = false) => (
  dispatch,
  getState,
) => {
  dispatch(kardiRxCctEcgTableDataRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  const kardiaRxCCTHistoryState = getState().kardiaRx.kardiaRxCCTPatientHistory
    .selectedPatinet;
    // console.log("kardiaRxCCTHistoryState=>", kardiaRxCCTHistoryState);
  let participantId;
  let connectionTemplateID;
  // console.log("params=>>", params);
  // work-list route
  if (
    kardiaRxCCTHistoryState &&
  //  kardiaRxCCTHistoryState.hasOwnProperty('connection_template_id')
    kardiaRxCCTHistoryState.hasOwnProperty('idtf_connection_id')
  ) {
    connectionTemplateID = kardiaRxCCTHistoryState.idtf_connection_id;
  }
  // Patient's recording list route
  else if (
    kardiaRxCCTHistoryState &&
    kardiaRxCCTHistoryState.hasOwnProperty('connectionTemplateID')
  ) {
    connectionTemplateID = kardiaRxCCTHistoryState.connectionTemplateID;
  }

  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;
      const apiCalls = [];
      if(connectionTemplateID){
        apiCalls.push(
          dispatch(fetchKardiaRxIdtfEcg(connectionTemplateID)),
        );
      } else {
        apiCalls.push(
          dispatch(fetchKardiaRxIdtfEcg(params.idtf_connection_id)),
        );
      }
      
      return Promise.all(apiCalls);
    })
    .then(data => {
      return dispatch(kardiRxCctEcgTableDataSuccess(data));
    })
    .catch(err => {
      dispatch(kardiRxCctEcgTableDataFailure(err));
    });
};

export const updatedSelectedKardiaRxPatient = data => dispatch => {
  dispatch(updateRxPatient(data));
};

export const updatedSelectedRxRecording = data => dispatch => {
  dispatch(updateRxRecording(data));
};


export const kardiaRxCctResendEosReport = (params, forceUpdate = false) => (
  dispatch,
  getState,
) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);

  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const apiCalls = [];
        apiCalls.push(
          dispatch(cctResendEosReport(params)),
        );
      
      return Promise.all(apiCalls);
    })
    .then(data => {
      return data
    })
    .catch(err => {
      return err
    });
};


export const kardiaRxCctCompletedCheckbox = (params, forceUpdate = false) => (
  dispatch,
  getState,
) => {

  const meDataSource = getDataSource(getState(), DATASOURCES.ME);

  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const apiCalls = [];
        apiCalls.push(
          dispatch(cctCompletedCheckboxPatientDrawer()),
        );
      
      return Promise.all(apiCalls);
    })
    .then(data => {
      return data
    })
    .catch(err => {
      console.log("err=>>", err);
      // dispatch(kardiRxCctEcgTableDataFailure(err));
      return err
    });
};


// WEBPACK FOOTER //
// ./src/views/state/KardiaRxCCTPatientHistory/KardiaRxCCTPatientHistoryActions.js